import { useEffect } from 'react';

interface SeoJsonLdProps {
  schemas: object[];
}

export default function SeoJsonLd({ schemas }: SeoJsonLdProps) {
  useEffect(() => {
    const inserted: HTMLScriptElement[] = [];

    schemas.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `jsonld-schema-${i}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      inserted.push(script);
    });

    return () => {
      inserted.forEach((s) => {
        if (document.head.contains(s)) document.head.removeChild(s);
      });
    };
  }, []);

  return null;
}
